export default "__VITE_ASSET__e53ce030__"